@if (mobile) {
  <div class="mobile-dropfile position-relative d-flex flex-column justify-content-center align-items-center">
    <input #fileinput class="cursor-pointer" type="file" (change)="uploadFile($event)" multiple>
    <fa-icon size="lg" icon="paperclip"></fa-icon>
  </div>
} @else {
  <label class="fw-bold">Pièce(s) jointe(s)</label>
  @if (sendedFiles.length > 0) {
    <table aria-describedby="liste des fichiers" class="table table-striped responsive">
      <thead>
        <tr>
          <th scope="col">Fichier</th>
          <th scope="col">Taille</th>
          <th scope="col" class="action">Action</th>
        </tr>
      </thead>
      <tbody>
        @for (file of sendedFiles; track file) {
          <tr>
            <td class="overflow-wrap fw-sm-bold">
              {{ file.filename }}
            </td>
            <td>
              @if (file.progress > 0) {
                <div class="progress form-group">
                  <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="file.progress">
                  </div>
                </div>
              } @else {
                @if (file.toolarge) {
                  <div class="text-danger">
                    Poids maximal de 10 Mo atteint ({{ file.size | octet }}), veuillez utiliser un lien de partage (disponible
                    dans le menu Outils / PsiTranfer) ou réduire le poids de la pièce.
                  </div>
                }
                @if (!file.toolarge) {
                  <div>
                    {{ file.size | octet }}
                  </div>
                }
              }
            </td>
            <td class="action d-table-cell">
              <div class="d-flex justify-content-center h-100">
                @if (file.progress > 0) {
                  <span ngbTooltip="Annuler" class="text-danger">
                    <fa-icon icon="times" size="lg" (click)="cancelUpload(file)"></fa-icon>
                  </span>
                } @else {
                  @if (!file.toolarge) {
                    <span ngbTooltip="Supprimer" class="text-danger">
                      <fa-icon icon="trash-alt" size="lg" (click)="deleteFile(file)"></fa-icon>
                    </span>
                  }
                  @if (file.toolarge) {
                    <span ngbTooltip="OK" class="text-info">
                      <fa-icon icon="check" size="lg" (click)="deleteFile(file)"></fa-icon>
                    </span>
                  }
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
  <div class="dropfile position-relative d-flex flex-column justify-content-center align-items-center">
    <input #fileinput class="cursor-pointer" type="file" (change)="uploadFile($event)" multiple>
    <fa-icon icon="upload" size="2x"></fa-icon>
    <span class="d-none d-md-inline-block">Cliquer pour sélectionner des fichiers ou les glisser-déposer ici.</span>
  </div>
}
